const zhCN = {
  exportBtn: '导出记录',

  personTypeTxt: '选择人员类型',
  option_allType: '全部人员类型',

  startTimeTxt: '开始时间',
  endTimeTxt: '结束时间',
  aWeekBeforeBtn: '前一周',
  oneMonthBeforeBtn: '前一个月',
  threeMonthsBeforeBtn: '前三个月',

  deviceOrgTxt: '所属机构',
  personalOrDeviceNameTxt: '姓名/设备名称',
  searchBtn: '搜索',

  listOrg: '组织名称',
  listDeviceSN: '设备SN',
  listDeviceName: '设备名称',
  listPersonalType: '人员类型',
  listPersonalName: '姓名',
  listIDNumber: '证件号',
  listMaskCheck: '口罩检测',
  listTemperature: '体温',
  listRM: '识别方式',
  listRecognitionTime: '识别时间',
  listSitePhotos: '现场照',

  getRecogInfoFail: '获取识别记录失败！',

  photoModalTitle: '现场照片',
  closeBtn: '关闭',

  exportModalTitle: '导出记录',
  confirmBtn: '提交',
  cancelBtn: '取消',

  exportField: '选择导出字段',
  exportTips: 'return "已选中  " + count + " 条识别记录"',
  f_Organization: '机构名称',
  f_DeviceSN: '设备SN',
  f_DeviceName: '设备名称',
  f_Surname: '姓名',
  f_IDNumber: '证件号',
  f_MaskCheck: '口罩检测',
  f_Temp: '体温温度',
  f_RM: '识别方式',
  f_RecognitionTime: '识别时间',
  f_SitePhotos: '现场照',

  exportWarning: '请至少选择一个导出字段！',
  exportFilePrefix: '识别记录',
  exportSuccess: '导出成功！'
}
const enUS = {
  exportBtn: 'Export',
  
  personTypeTxt: 'Personnel Type',
  option_allType: 'All',

  startTimeTxt: 'Start Time',
  endTimeTxt: 'End Time',
  aWeekBeforeBtn: 'a week before',
  oneMonthBeforeBtn: 'one month before',
  threeMonthsBeforeBtn: 'three months before',

  deviceOrgTxt: 'Organization',
  personalOrDeviceNameTxt: 'Personal/Device Name',
  searchBtn: 'Search',

  listOrg: 'Organization',
  listDeviceSN: 'Device SN',
  listDeviceName: 'Device Name',
  listPersonalType: 'Personnel Type',
  listPersonalName: 'Name',
  listIDNumber: 'ID Number',
  listMaskCheck: 'Mask Check',
  listTemperature: 'Temp',
  listRM: 'RM',
  listRecognitionTime: 'RT',
  listSitePhotos: 'Photos',

  getRecogInfoFail: 'Get recognition record failed!',

  photoModalTitle: 'Site Photos',
  closeBtn: 'Close',

  exportModalTitle: 'Export Records',
  confirmBtn: 'Confirm',
  cancelBtn: 'Cancel',

  exportField: 'Export Field',
  exportTips: 'return count + " records have been selected"',
  f_Organization: 'Organization',
  f_DeviceSN: 'Device SN',
  f_DeviceName: 'Device Name',
  f_Surname: 'Surname',
  f_IDNumber: 'ID Number',
  f_MaskCheck: 'Mask Check',
  f_Temp: 'Temp',
  f_RM: 'RM',
  f_RecognitionTime: 'RT',
  f_SitePhotos: 'Site Photos',

  exportWarning: 'Please select at least one export field!',
  exportFilePrefix: 'Identification Record',
  exportSuccess: 'Export successful!'
}

export default { zhCN, enUS }